import { Typography, Card, CardContent, CardMedia, Button, Stack } from '@mui/material';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import { IDataProdutosPedidos } from '../../../../../../../../types/api/comercial/pedidos-pesquisar-produtos';
import { formatarValorMonetario } from '../../../../../../../../helpers/masks';
import { EstoqueChips } from './EstoqueChips';

export interface ProdutoListItemProps {
    produto: IDataProdutosPedidos;
    handleAddClick: (produto: IDataProdutosPedidos) => void;
    publico_fazendeiro: boolean;
}

export function ProdutoListItem({ produto, handleAddClick, publico_fazendeiro }: ProdutoListItemProps) {
    return (
        <Card sx={{
            mb: 1,
            display: 'flex',
            border: '1px solid #e0e0e0',
            boxShadow: 'none',
            height: '80px' // Altura fixa mais compacta
        }}>
            <CardMedia
                component="img"
                sx={{ width: 80, height: 80, objectFit: 'cover' }}
                image={produto.imagem?.url || "/imgs/imagem-invalida.png"}
                alt={produto.nome}
            />
            <Stack direction="row" flexGrow={1} alignItems="center">
                <CardContent sx={{ flex: '1 0 auto', py: 0.5, px: 1.5 }}>
                    <Typography variant="body2" component="div" noWrap>
                        {produto.nome}
                    </Typography>
                    <Stack direction="row" justifyContent="flex-start" alignItems="center" mt={0.5} spacing={2}>
                        <Typography variant="subtitle1" color="text.primary">
                            {formatarValorMonetario(produto.menor_preco)}
                        </Typography>
                        <Stack direction="row" flexWrap="wrap" gap={0.5}>
                            <EstoqueChips produto={produto} publico_fazendeiro={publico_fazendeiro} />
                        </Stack>
                    </Stack>
                </CardContent>
                <Stack alignItems="center" p={1}>
                    <Button
                        variant="contained"
                        size="medium"
                        onClick={() => handleAddClick(produto)}
                        disabled={(produto.estoque_total === 0) || (produto.estoque[0]?.emite_receita === "S" && !publico_fazendeiro)}
                        sx={{ minWidth: '32px', px: 1 }}
                    >
                        <AddShoppingCartIcon fontSize="small" />
                    </Button>
                </Stack>
            </Stack>
        </Card>
    );
}